import { useAuth0 } from "@auth0/auth0-react";
import { RotatingLines } from "react-loader-spinner";
import axiosClient from "../../services/apiClient";
import { addAccessTokenInterceptor } from "../../services/apiClient";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Button from "@mui/material/Button";

import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import TabPanel from "../../components/TabPanel";

import DateRangeSelector from "../../components/DateRangeSelector";
import UnitEventsTable from "./unitEventsTable";
import { buildEventsAllBuildings } from "./unitEventsUtils";
import BuildingEventsTable from "./buildingEventsTable";

type Building = {
  LatLong: [number, number];
  buildingId: string;
  name: string;
};

function Loader() {
  return (
    <RotatingLines
      strokeColor="grey"
      strokeWidth="5"
      animationDuration="0.75"
      width="96"
      visible={true}
    />
  );
}

type SensorData = {
  AlarmResponses: number;
  Alarms: number;
  Shutdowns: number;
  AvgSessionLength: number;
  ExposedBurnerAccTime: number;
  Fire: number;
  IsStoveRemoteUnlocked: "LOCKED" | "UNLOCKED" | "NULL";
  MaxSessionIntensity: number;
  NumberOfSessions: number;
  PCOFWVersion: string;
  PresenceCounter: number;
  PresenceRatio: number;
  SCSFWVersion: string;
  SensorID: string;
  Status: "Online" | "Offline";
  TooHotAccTime: number;
  UnitNumber: string;
  Warnings: number;
  isPCOconnected: "YES" | "NO" | "NULL";
  isStoveInUse: "YES" | "NO";
  stoveCurrent: string; // could also be number if guaranteed numeric
  stoveStatus: "ON" | "OFF";
  lastActive: string;
  ambientTemp: string; // could also be number
};

type SensorDataArray = SensorData[];
type InsightsProps = {
  result: SensorDataArray;
  setResult: React.Dispatch<React.SetStateAction<SensorDataArray>>;
};

export default function Insights({ result, setResult }: InsightsProps) {
    const buildings = [
      {
        buildingId: "a1a7b320-acc1-4e75-be64-e6cb6c1fd7b4",
        name: "9801 International Drive Orlando, FL 32819",
        LatLong: [28.42695, -81.46817],
      },
      {
        buildingId: "14899cda-adc6-49e4-8e03-dbcb98699fee",
        name: "Tradeshow 2",
        LatLong: [28.42, -81.4725],
      },
      {
        buildingId: "14899cda-adc6-49e4-8e03-dbcb98699fe1",
        name: "Tradeshow 3",
        LatLong: [28.4389, -81.4583],
      },
      {
        buildingId: "14899cda-adc6-49e4-8e03-dbcb98699fe2",
        name: "Tradeshow 3",
        LatLong: [28.4156, -81.4632],
      },
      {
        buildingId: "14899cda-adc6-49e4-8e03-dbcb98699fe3",
        name: "Tradeshow 3",
        LatLong: [28.434, -81.4807],
      },
    ];
  const [level, setLevel] = useState(0);
  const { isAuthenticated, getAccessTokenSilently, getIdTokenClaims } =
    useAuth0();
  const [buildingsEventData, setBuildingsEventData] =
    useState<any[]>(buildings);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [building, setBuilding] = useState<Building>({
    LatLong: [0, 0],
    buildingId: "",
    name: "",
  });

  const [tenantName, setTenantName] = useState("Cooktop Safety");
  const [AreBuildingsLoading, setAreBuildingsLoading] = useState(false);

  const handleChange = (newValue: number) => {
    setLevel(newValue);
  };

  const handleIntervalChange = (startDate: Date, endDate: Date) => {
    setStartDate(startDate);
    setEndDate(endDate);
  };

  useEffect(() => {
      setTimeout(() => {
        setAreBuildingsLoading(false);
    }, 2000)
  }, []);

  useEffect(() => {
    if (building.buildingId !== "") {
      setLevel(1);
    }
  }, [building]);

  const handleLoadUnitsData = (selectedBuilding: string) => {
    if (selectedBuilding === building.buildingId) {
      // No need to set the building again, we are returning to the same building
      setLevel(1);
      return;
    }
    for (let index = 0; index < buildingsEventData.length; index++) {
      if (buildingsEventData[index].buildingId == selectedBuilding) {
        setBuilding(buildingsEventData[index]);
        break;
      }
    }
  };

  return (
    <div className="container mx-auto mt-32 mb-60 overflow-x-scroll ">
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}></Box>
        <DateRangeSelector setInterval={handleIntervalChange} />
        {level === 1 && (
          <div className="inline-block float-right ml-9 mt-3">
            <Button
              variant="outlined"
              startIcon={<ArrowBackIosIcon />}
              onClick={() => handleChange(0)}
            >
              {" "}
              Properties
            </Button>
          </div>
        )}
        <TabPanel value={level} index={0}>
          {
            <>
              {AreBuildingsLoading ? (
                <Loader />
              ) : (
                <BuildingEventsTable
                  data={buildingsEventData}
                  loadUnitsData={handleLoadUnitsData}
                  organization={tenantName}
                />
              )}
            </>
          }
        </TabPanel>
        <TabPanel value={level} index={1}>
          {
            <>
              {
                <UnitEventsTable
                  building={building}
                  startDate={startDate}
                  endDate={endDate}
                  result={result}
                  setResult={setResult}
                />
              }
            </>
          }
        </TabPanel>
      </Box>
    </div>
  );
}
